import { forwardRef, Icon, IconProps } from '@chakra-ui/react';
import Box from '../../Box/Box';

const WarningYellow = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <Box
      as="path"
      clipRule="evenodd"
      d="M6.27461 2.44339L1.26533 10.9886C0.483748 12.3219 1.44524 14.0001 2.99073 14.0001H13.0093C14.5548 14.0001 15.5163 12.3219 14.7347 10.9886L9.7254 2.4434C8.95273 1.12531 7.04728 1.12531 6.27461 2.44339Z"
      fill="yellow.80"
      fillRule="evenodd"
    />
    <Box as="path" d="M8.75 9.00007V5.00007H7.25V9.00007H8.75Z" fill="purple.10" />
    <Box as="path" d="M8.75 11.5001V10.0001H7.25V11.5001H8.75Z" fill="purple.10" />
  </Icon>
));

export default WarningYellow;
